import auth from "../api/auth";
import {useEffect, useState} from "react";
import FAQS from "../models/FAQs";
import FAQContainer from "../components/FAQContainer";
import {useSearchParams} from "react-router-dom";

const FAQ = () => {
    const [questions, setQuestions] = useState([])
    const [params, setParams] = useSearchParams()

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'instant'});
    }, []);

    useEffect(() => {
        if (auth.isAuthenticated() && params.get('shortFAQ') !== 'true') {
            setQuestions(FAQS.FAQS)
        }
        else {
            setQuestions(FAQS.SHORT_FAQS)
        }

    },[])

    useEffect(() => {
        const scrollParam = params.get("scrollTo");
        if (scrollParam !== "subscription") return;

        // short delay so the FAQ items are rendered
        setTimeout(() => {
            const allQuestions = document.querySelectorAll(".faq-question-text");
            const target = Array.from(allQuestions).find(el =>
                el.textContent.includes("How do I manage my subscription plan?")
            );

            if (target) {
                target.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 100);
    }, [questions, params]);

    return(
        <>
            <div className="faq-page-container">
                <div className="faq-page-title">FAQ/ Self Help Guide</div>
                <div className="faq-page-guide">
                    For <span className="extra-bold">Video Tours</span> or <span className="extra-bold">supporting guidance</span> on
                    how to interpret the reports & create the right coaching, visit <a
                    href="https://clutterbuck-cmi.com/perill-guides" target="_blank" rel="noopener noreferrer">
                    https://clutterbuck-cmi.com/perill-guides
                </a>.
                </div>
                <div className="privacy-policy-container home-contents">
                    {questions && questions.map((section, sIdx) => (
                        <div key={sIdx} className="faq-section">
                            <div className="faq-section-heading">{section.heading}</div>
                            {section.items.map((question, qIdx) => (
                                <FAQContainer question={question} idx={qIdx} key={qIdx} />
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default FAQ